import { Component, OnInit, Input } from '@angular/core';
import { CommentInterface } from '../types/comment.interface';
import { CommentsService } from '../comments.service';
import { ActiveCommentInterface } from '../types/activeComment.interface';
import { ActivatedRoute } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { PersonService } from 'src/app/services/person.service';
import { Tier3 } from 'src/app/models/obs/tier3'; 

@Component({
  selector: 'app-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrl: './comment-list.component.scss'
})
export class CommentListComponent implements OnInit {

  @Input() Tier3!: Tier3;
  currentUserId: string = '0';
  comments: CommentInterface[] = [];
  activeComment: ActiveCommentInterface | null = null;

  constructor(
    private commentService: CommentsService,
    private activedRoute: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private personService: PersonService
  ) { }

  ngOnInit() {
    this.actualUserIsLoged();
    this.loadComments();
  }

  actualUserIsLoged() {
    const userId = this.tokenStorage.getUser().id
    if (userId) {
      this.personService.getOneByUserId(userId).subscribe(
        res => {
          this.currentUserId = res['0'].id;
        },
        err => {
          console.log(err);
        }
      )
    }
  }

  loadComments() {
    this.commentService.getComments(this.Tier3.id).subscribe(
      res => {
        this.comments = res['data'];
      },
      err => {
        console.log(err);
      }
    )
  }

  getRootComments(): CommentInterface[] {
    return this.comments.filter((comment) => comment.parentId === null);
  }

  addComment({ info, parentId }: { info: CommentInterface; parentId: string | null; }): void {
    info.parentId = parentId;
    info.tier3Id = this.Tier3.id;
    this.commentService.createComment(info).subscribe(
      res => {
        /* console.log("Comentario nuevo agregado devulve : ", res['0']); */

        this.currentUserId = res['0'].userId;
        this.comments = [res['0'], ...this.comments];
        this.activeComment = null;
      },
      err => {
        console.log(err);
      }
    )
  }

  getReplies(commentId: string): CommentInterface[] {
    return this.comments.filter((comment) => comment.parentId == commentId).sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  setActiveComment(activeComment: ActiveCommentInterface | null): void {
    this.activeComment = activeComment;
  }

  updateComment({ info, commentId, }: { info: CommentInterface; commentId: string; }): void {
    info.userId = this.currentUserId;
    this.commentService.updateComment(commentId, info).subscribe(
      (updatedComment) => {
        this.comments = this.comments.map((comment) => {
          if (comment.id === commentId) {
            return updatedComment['0'];
          }
          return comment;
        });
        this.activeComment = null;
      });
  }

  deleteComment(commentId: string): void {
    this.commentService.deleteComment(commentId).subscribe(
      () => {
        this.comments = this.comments.filter(
          (comment) => comment.id !== commentId
        );
      });
  }


}
